// extracted by mini-css-extract-plugin
module.exports = {"translations-button":"SavedSectionEdit_translations-button__zR5-b","section-info":"SavedSectionEdit_section-info__14pC9"};